import { render, staticRenderFns } from "./RallyRoundStatusTable.vue?vue&type=template&id=215b51ce&"
import script from "./RallyRoundStatusTable.vue?vue&type=script&lang=ts&"
export * from "./RallyRoundStatusTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports